var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"button is-primary is-outlined navbar-item",on:{"click":_vm.goBack}},[_c('span',{staticClass:"arrow-back",domProps:{"innerHTML":_vm._s(require('!html-loader!@/assets/img/arrow-left.svg'))}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }